import * as yup from 'yup';
import { tokenBaseValidation } from 'utils/validation';

const lockedPeriodBaseValidation = yup
  .number()
  .transform((value) => (isNaN(value) ? undefined : value))
  .positive()
  .integer();

type InputNumberType = {
  label?: string;
  min: number;
  max: number;
  required: boolean;
};
type InputTokenAmount = {
  label?: string;
  min: string;
  max: string;
  decimals: number;
  required: boolean;
};

export function createStakeValidation({
  tokenAmount,
  lockedPeriod,
}: {
  tokenAmount: InputTokenAmount;
  lockedPeriod: InputNumberType;
}) {
  const tokenValidation = tokenBaseValidation
    .label(tokenAmount.label ?? '')
    .bnMin(
      tokenAmount.min,
      tokenAmount.decimals,
      '${label} must be greater than ${min}'
    )
    .bnMax(tokenAmount.max, tokenAmount.decimals, 'Insufficient balance');

  const lockedPeriodValidation = lockedPeriodBaseValidation
    .label(lockedPeriod.label ?? '')
    .min(lockedPeriod.min)
    .max(lockedPeriod.max);

  return yup.object({
    tokenAmount: tokenAmount.required
      ? tokenValidation.required()
      : tokenValidation.notRequired(),
    lockedPeriod: lockedPeriod.required
      ? lockedPeriodValidation.required()
      : lockedPeriodValidation.notRequired(),
  });
}

export function createExtendValidation({
  lockedPeriod,
}: {
  lockedPeriod: InputNumberType;
}) {
  const lockedPeriodValidation = lockedPeriodBaseValidation
    .label(lockedPeriod.label ?? '')
    .min(lockedPeriod.min)
    .max(lockedPeriod.max);

  return yup.object({
    lockedPeriod: lockedPeriod.required
      ? lockedPeriodValidation.required()
      : lockedPeriodValidation,
  });
}

export function createWithdrawValidation({
  tokenAmount,
}: {
  tokenAmount: InputTokenAmount;
}) {
  const tokenValidation = tokenBaseValidation
    .label(tokenAmount.label ?? '')
    .bnMax(tokenAmount.max, tokenAmount.decimals, 'Insufficient balance')
    .bnMin(
      tokenAmount.min,
      tokenAmount.decimals,
      '${label} must be greater than ${min}'
    );

  return yup.object({
    tokenAmount: tokenAmount.required
      ? tokenValidation.required()
      : tokenValidation,
  });
}
